import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type StoreService from 'ember-data/store';
import type TasApplicationModel from 'tio-common/models/tas-application';
import type { ModelFrom } from 'tio-employee/types/route-model';
import type TasRoute from '../../../tas';
import { REIMAGINED_TAS_APPLICATION_INCLUDES } from 'tio-employee/utils/tas/reimagined-includes';

export default class AuthenticatedCareerPathwaysTasApplicationsTypeTwoNewRoute extends Route {
  @service declare store: StoreService;

  async model(params: Record<string, unknown>) {
    const applicationId = params['tas_application_id'] as string;
    const application = await this.store.findRecord<TasApplicationModel>(
      'tas-application',
      applicationId,
      {
        include: REIMAGINED_TAS_APPLICATION_INCLUDES.join(','),
        reload: true,
      }
    );

    return {
      ...(this.modelFor('authenticated.reimagined.tas') as ModelFrom<TasRoute>),
      applicationId,
      applicationType: 'type-two',
      application,
    };
  }
}
